import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance_create = get_axios_instance(api_variables.SERVICE_ITDECLARATION_DEDUCTION_CREATE);
var axios_instance_get = get_axios_instance(api_variables.SERVICE_ITDECLARATION_DEDUCTION_GET);
var axios_instance_get_particulars = get_axios_instance(api_variables.SERVICE_ITDECLARATIONS_GET_PARTICULARS);
const _pk_name = "id";

const state = {
    data: [],
    particulars: [],
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data);
    },
    setParticulars: (state, payload) => {
        state.particulars = payload;
    },
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
    async fetchAll({ commit }, payload) {
        //console.log("[state/overview/utilities/deduction/fetchAll] Calling API...");
        try {
            commit("setFetching", true);
            let res = await axios_instance_get.get(`/`, {
                params: {
                    id: payload
                }
            });
            commit("setFetching", false);
            //console.log("[state/overview/utilities/deduction/fetchAll] res: ", res);
            if (res.status == 200) {
                commit("set", res.data.payload.data);
            }
            return res;
        } catch (err) {
            //console.log(err)
        }
    },
    async fetchParticulars({ commit }) {
        //console.log("[state/overview/utilities/deduction/fetchParticulars] Calling API...");
        try {
            commit("setFetching", true);
            let res = await axios_instance_get_particulars.get(`/`);
            commit("setFetching", false);
            //console.log("[state/overview/utilities/deduction/fetchParticulars] res: ", res);
            if (res.status == 200) {
                commit("setParticulars", res.data.payload.data);
            }
            return res;
        } catch (err) {
            //console.log(err)
        }
    },

    async create({ commit }, payload) {
        //console.log("[state/overview/utilities/deduction/create] Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance_create.post('/', payload);
            commit("setSaving", false);
            //console.log("[state/overview/utilities/deduction/create] res: ", res);
            if (res.status == 200) {
                // commit("addReviseSalary", res.payload.data);
            }
            return res;
        } catch (err) {
            //console.log(err)
        }
    },

    async update({ commit }, payload) {
        //console.log("[state/overview/utilities/deduction/update] Updating... Display payload", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance_create.put('/', payload);
            commit("setSaving", false);
            //console.log("[state/overview/utilities/deduction/update] res: ", res);
            // if(res.status == 200) {
            // commit("updateReviseSalary", res);
            // }
            return res;
        } catch (err) {
            //console.log(err)
        }
    },

    async delete({ commit }, payload) {
        //console.log("[state/overview/utilities/deduction/delete] Payload:", payload);
        //console.log("[state/overview/utilities/deduction/delete] Payload:", `/${payload.id}`);
        try {
            commit("setDeleting", true);
            let res = await axios_instance_create.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                // commit("removeReviseSalary", payload.id);
            }
        } catch (err) {
            //console.log(err)
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}